module.exports = __webpack_public_path__ + "home-block-1-ico-2-2MJNjMK.png";